// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__22wOT","header":"ClearentDisclaimer_header__3ENlO","inner":"ClearentDisclaimer_inner__2d-yM"};